export const EXTERNAL_PERMISSIONS = {
  create_character: "create_character",
  delete_character: "delete_character",
  report_character: "report_character",
  view_chats: "view_chats",
  view_my_chat_bots: "view_my_chat_bots",
  view_help: "view_help",
  create_user_external: "create_user_external",
};

export const ALL_EXTERNAL_PERMISSIONS = [
  EXTERNAL_PERMISSIONS.create_character,
  EXTERNAL_PERMISSIONS.delete_character,
  EXTERNAL_PERMISSIONS.report_character,
  EXTERNAL_PERMISSIONS.view_chats,
  EXTERNAL_PERMISSIONS.view_my_chat_bots,
  EXTERNAL_PERMISSIONS.view_help,
  EXTERNAL_PERMISSIONS.create_user_external,
];

export const PERMISSIONS_BAN_TYPES = {
  restriction_temporary: "restriction_full_time",
  limited_access: "restriction_limited",
  restriction_complete: "restriction_full",
};

export const SPICYCHAT_USER_PERMISSIONS = {
  skip_waiting_room: "skip_waiting_room",
  "4k_context": "4k_context",
  priority_queue: "priority_queue",
  avatar_images_v2: "avatar_images_v2",
  conversation_images: "conversation_images",
  conversation_images_v2: "conversation_images_v2",
  image_training: "image_training",
  generation_settings: "generation_settings",
  "8k_context": "8k_context",
  "16k_context": "16k_context",
  "32k_context": "32k_context",
  model_70b: "model_70b",
  model_mixtral: "model_mixtral",
  memory_manager: "memory_manager",
  conversation_memory_auto: "conversation_memory_auto",
  character_translate_public: "character_translate_public",
  character_translate_private: "character_translate_private",
  admin: "admin",
};
